export function Footer() {
  return (
    <footer className="py-8 px-4 border-t border-border">
      <div className="max-w-4xl mx-auto flex flex-col sm:flex-row items-center justify-between gap-4 text-sm text-muted-foreground">
        <div className="flex items-center gap-2">
          <picture>
            <source
              srcSet="/logo_white.png"
              media="(prefers-color-scheme: dark)"
            />
            <img
              src="/logo.png"
              alt="Open1031"
              className="h-5 w-auto opacity-70"
            />
          </picture>
          <span>© 2026 Open1031</span>
        </div>
        <nav aria-label="Legal links">
          <ul className="flex gap-6 list-none">
            <li>
              <a
                href="/privacy"
                className="hover:text-foreground transition-colors"
              >
                Privacy
              </a>
            </li>
            <li>
              <a
                href="/terms"
                className="hover:text-foreground transition-colors"
              >
                Terms
              </a>
            </li>
          </ul>
        </nav>
      </div>
    </footer>
  );
}
